import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import NavBarMobile from "./NavBarMobile";
import NavbarPC from "./NavbarPC";

import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../api/xoicom.reducer";
import { Link, useLocation } from "react-router-dom";

import "../../style/NavBar.css";
import { useMediaQuery } from "@mui/material";
import { breakpoint } from "../../utils/responsiveUtils";

function NavBar({ language }) {
  const mode = useSelector((state) => state.reducer.navbarMode);
  const navbarText = useSelector((state) => state.reducer.navbarText);

  const pages = Object.keys(navbarText.pages).map((key) => ({
    name: key,
    displayName: navbarText.pages[key],
  }));
  const [activePage, setActivePage] = useState();
  const [navbar, setNavBar] = useState(false);
  const [hidden, setHidden] = useState(false);
  const oldScrollRef = useRef(0);

  useEffect(() => {
    const changeNavBar = () => {
      if (window.scrollY > 0) {
        if (oldScrollRef.current < window.scrollY) {
          // scrolling down
          setNavBar(false);
          setHidden(true);
        } else {
          // scrolling up
          setNavBar(true);
          setHidden(false);
        }
        oldScrollRef.current = window.scrollY;
      } else {
        // at top
        setNavBar(false);
        setHidden(false);
      }
    };
    window.addEventListener("scroll", changeNavBar);
    return () => window.removeEventListener("scroll", changeNavBar);
  }, []);

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/")[1];
    setActivePage(path);
  }, [location.pathname]);

  useEffect(() => {
    changeLanguage(language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();
  const changeLanguage = (language) => {
    dispatch(setLanguage(language));
  };

  const mobile = useMediaQuery(breakpoint.mobileSm);
  return (
    <Box
      className={`navbar ${
        navbar
          ? "navbar-scroll"
          : `navbar-default display-navbar-${hidden ? "none" : "block"}`
      }`}
    >
      {mobile ? (
        <div style={{ margin: "8px 24px", display: "flex" }}>
          {/* {logo} */}
          <XoiComLogo navbar={navbar} mode={mode} />
          <NavBarMobile
            pages={pages}
            activePage={activePage}
            language={language}
            changeLanguage={changeLanguage}
            color={navbar ? "black" : mode === "light" ? "white" : "black"}
            text={navbarText}
          />
        </div>
      ) : (
        <NavbarPC
          logo={<XoiComLogo navbar={navbar} mode={mode} />}
          pages={pages}
          activePage={activePage}
          language={language}
          changeLanguage={changeLanguage}
          color={navbar ? "black" : mode === "light" ? "white" : "black"}
          navbar={navbar}
          mode={mode}
        />
      )}
    </Box>
  );
}

function XoiComLogo({ navbar, mode }) {
  const lightLogo = "header-logo-light";
  const darkLogo = "header-logo-dark";
  const logoClass = navbar ? darkLogo : mode === "light" ? lightLogo : darkLogo;

  return (
    <div className="navbar-logo-container">
      <Link
        className={`header-logo-drawer clickable ${logoClass}`}
        to="home"
        alt="xoi-com-logo"
      ></Link>
    </div>
  );
}

export default NavBar;
